import { Box, Typography } from '@mui/material';
import { FnaListItem } from '../../../common/types/analyses';
import { getFormattedDate } from '../../../common/lib/date';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { JSX } from 'react';

interface FnaNeedProps {
  /**
   * Title of the need
   */
  title: string;
  /**
   * Number of needs
   */
  count: number;
  /**
   * Optional class name to apply to the component
   */
  className?: string;
}

/**
 * FNA need component
 */
const FnaNeed = ({ title, count, className }: FnaNeedProps): JSX.Element => {
  return (
    <Box className={className}>
      <Typography>{title}</Typography>
      <Typography fontWeight="bold">{count && count != 0 ? count : '-'}</Typography>
    </Box>
  );
};

/**
 * Cell renderer for FNA details
 */
const FnaDetailsCell = ({ row }: GridRenderCellParams<FnaListItem>): JSX.Element => (
  <Box className="md:flex md:space-x-4 space-y-4 md:space-y-0">
    <Box>
      <Typography variant="subtitle1" fontWeight={700}>
        {row.roleplayerList}
      </Typography>
      <Box>
        <Typography>{row.description}</Typography>
        <Box className="flex space-x-2 divide-x">
          <Box className="flex space-x-2">
            <Typography lineHeight={1.2} color="text.secondary">
              Ref:
            </Typography>
            <Typography lineHeight={1.2}>{row.id}</Typography>
          </Box>
          <Box className="flex space-x-2 pl-2">
            <Typography lineHeight={1.2} color="text.secondary">
              Created:
            </Typography>
            <Typography lineHeight={1.2}>{getFormattedDate(row.created)}</Typography>
          </Box>
          <Box className="flex space-x-2 pl-2">
            <Typography lineHeight={1.2} color="text.secondary">
              Status:
            </Typography>
            <Typography lineHeight={1.2}>{row.fnaStateNote}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
    <Box className="flex space-x-4 divide-x">
      <FnaNeed title="Suretyship" className="md:border-l md:pl-4" count={row.suretyshipCount} />
      <FnaNeed title="Key person" count={row.keypersonCount} className="pl-4" />
      <FnaNeed title="Buy and Sell" count={row.buyandsellCount} className="pl-4" />
    </Box>
  </Box>
);

export default FnaDetailsCell;
